module.exports = __webpack_public_path__ + "assets/waterMeterIcon3.f2923475.svg";